export default "__VITE_ASSET__D97afuNm__"